import React from 'react';
import { List, Skeleton } from 'antd';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { StringParam, useQueryParam } from 'use-query-params';

import { parseSubjectName, useSubjectsData } from 'modules/global';

const SubjectsList = () => {
  const t = useTranslations();
  const { subjects, isLoading: subjectsLoading } = useSubjectsData();

  const [selectedSubject, setSelectedSubject] = useQueryParam('subject', StringParam);

  const handleSubjectClick = (subjectName: string) => {
    if (subjectName === t('barchasi')) {
      setSelectedSubject(undefined);
    } else {
      setSelectedSubject(subjectName);
    }
  };

  return (
    <div className="rounded-2xl bg-white p-4 shadow-md sm:col-span-1">
      <p className="text-sm text-gray-400">{t('Mavzular')}</p>

      {subjectsLoading ? (
        <div className="mt-4 space-y-3">
          {Array.from({ length: 10 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Skeleton.Button key={index} active className="!h-10 !w-full" />
          ))}
        </div>
      ) : (
        <div className="mt-2">
          <List
            loading={subjectsLoading}
            itemLayout="horizontal"
            dataSource={subjects?.subject}
            renderItem={item => {
              const isActive =
                parseSubjectName((selectedSubject as string) || t('barchasi')) === parseSubjectName(item?.name);

              return (
                <List.Item className="!py-1" onClick={() => handleSubjectClick(item.name)}>
                  <List.Item.Meta
                    className="cursor-pointer !items-center rounded-md !py-2 pl-4 transition-all"
                    style={{
                      background: isActive ? `${item.color}1f` : 'transparent',
                      borderRight: `3px solid ${isActive ? item.color : 'transparent'}`
                    }}
                    avatar={
                      <Image
                        src={item.image}
                        alt={item.name.slice(0, 1)}
                        loading="lazy"
                        width={32}
                        height={32}
                        title="Subject list"
                      />
                    }
                    title={
                      <span
                        style={{
                          color: isActive ? item.color : 'black',
                          fontWeight: isActive ? '500' : 'normal'
                        }}
                      >
                        {item.name}
                      </span>
                    }
                  />
                </List.Item>
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SubjectsList;
